module.exports = __webpack_public_path__ + "7a01cf2e480e95b261dcfd5e32c6bc9c.svg";